import { MapaRota } from '@sotran/lib-shipper';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import MilestoneMaker from '../../../../components/MilestoneMaker';
import { capitalizar } from '../../../../helpers/capitalizar';
import {
  formatarCnpjCpfIMask,
  formatarTonelada,
} from '../../../../helpers/formatador';
import { Spin } from '../../../../styles/global';
import {
  Button,
  Destino,
  GridButton,
  GridDados,
  GridRotas,
  Origem,
  Text,
} from './styles';

const DadosGerais = ({ detalhesDemanda }) => {
  const history = useHistory();
  const params = useParams();

  const [volume, setVolume] = useState();
  const [cadencia, setCadencia] = useState();
  const [clientesExpedidores, setClientesExpedidores] = useState([]);
  const [clientesRecebedores, setClientesRecebedores] = useState([]);

  useEffect(() => {
    if (detalhesDemanda.lotes !== undefined) {
      const { lotes } = detalhesDemanda;

      const totalVolume =
        detalhesDemanda.volumeTotal ||
        lotes.reduce((volumeItem, item) => volumeItem + item.volume, 0);

      const totalCadencia =
        detalhesDemanda.cadenciaDiariaTotal ||
        lotes.reduce((cadenciaItem, item) => cadenciaItem + item.cadencia, 0);

      setClientesExpedidores(detalhesDemanda.enderecoExpedidor);
      setClientesRecebedores(detalhesDemanda.enderecoRecebedor);

      setVolume(totalVolume);
      setCadencia(totalCadencia);
    }
  }, [detalhesDemanda]);

  const isGeoLocalizacao = () =>
    detalhesDemanda.enderecoExpedidor[0].latitudeCidade &&
    detalhesDemanda.enderecoExpedidor[0].longitudeCidade &&
    detalhesDemanda.enderecoRecebedor[0].latitudeCidade &&
    detalhesDemanda.enderecoRecebedor[0].longitudeCidade;

  function renderRotas(clienteEndereco) {
    return (
      <>
        <Text>{clienteEndereco.nomeCliente}</Text>
        <Text style={{ fontSize: 13 }}>
          {`${capitalizar(clienteEndereco.endereco)}, ${
            clienteEndereco.numero
          } `}
          - &nbsp;
          {capitalizar(clienteEndereco.bairro)}
        </Text>
      </>
    );
  }

  const contentEndereco = endereco => (
    <Text>
      {`${endereco.nomeCliente} - ${formatarCnpjCpfIMask(endereco.cnpj)}`}
    </Text>
  );

  return (
    <>
      {detalhesDemanda.enderecoOrigem !== undefined && (
        <Row>
          <Col span={9}>
            <GridButton>
              <Button
                type="primary"
                onClick={() =>
                  history.push(`../lotes/demanda/${params.demandaId}`)
                }
              >
                Editar
              </Button>
            </GridButton>
            <GridDados>
              <span>Produto</span>
              <p>{detalhesDemanda.produtoNome}</p>
            </GridDados>
            <GridDados>
              <span>Volume total</span>
              <p>{`${formatarTonelada(volume, 0, 'toneladas')}`}</p>
            </GridDados>
            <GridDados>
              <span>Cadência diária total</span>
              <p>
                {`${formatarTonelada(cadencia, 0, 'toneladas')} (${
                  detalhesDemanda.livreConcorrencia
                    ? 'livre concorrência'
                    : 'cota'
                })`}
              </p>
            </GridDados>
            <GridDados>
              <span>Cliente pagador</span>
              <p>
                {`${
                  formatarCnpjCpfIMask(detalhesDemanda.cnpjClientePagador)
                    ? detalhesDemanda.razaoSocialClientePagador
                    : ''
                } - ${
                  detalhesDemanda.cnpjClientePagador
                    ? formatarCnpjCpfIMask(detalhesDemanda.cnpjClientePagador)
                    : ''
                }`}
              </p>
            </GridDados>

            {detalhesDemanda.numPedidoCliente && (
              <GridDados>
                <span>Número do pedido</span>
                <p>{detalhesDemanda.numPedidoCliente}</p>
              </GridDados>
            )}

            <GridRotas>
              <span>Rota</span>
              {!Object.keys(clientesExpedidores).length > 0 &&
              !Object.keys(clientesRecebedores).length > 0 ? (
                <Spin size="small" />
              ) : (
                <MilestoneMaker
                  origem={`${capitalizar(clientesExpedidores[0]?.cidade)} - ${
                    clientesExpedidores[0]?.estado
                  }`}
                  destino={`${capitalizar(clientesRecebedores[0]?.cidade)} - ${
                    clientesRecebedores[0]?.estado
                  }`}
                >
                  <Origem>
                    {clientesExpedidores.map(endereco => renderRotas(endereco))}
                  </Origem>
                  <Destino>
                    {clientesRecebedores.map(endereco => renderRotas(endereco))}
                  </Destino>
                </MilestoneMaker>
              )}
            </GridRotas>

            <GridDados>
              <span>Remetente</span>
              {detalhesDemanda.enderecoOrigem &&
                detalhesDemanda.enderecoOrigem.map(endereco =>
                  contentEndereco(endereco)
                )}
            </GridDados>
            <GridDados>
              <span>Expedidor</span>
              {detalhesDemanda.enderecoExpedidor &&
                detalhesDemanda.enderecoExpedidor.map(endereco =>
                  contentEndereco(endereco)
                )}
            </GridDados>
            <GridDados>
              <span>Recebedor</span>
              {detalhesDemanda.enderecoRecebedor &&
                detalhesDemanda.enderecoRecebedor.map(endereco =>
                  contentEndereco(endereco)
                )}
            </GridDados>
            <GridDados>
              <span>Destinatário</span>
              {detalhesDemanda.enderecoDestino &&
                detalhesDemanda.enderecoDestino.map(endereco =>
                  contentEndereco(endereco)
                )}
            </GridDados>
          </Col>
          <Col span={15}>
            {isGeoLocalizacao() && (
              <MapaRota
                loading={false}
                mapHeight="65vh"
                startPosition={{
                  latitude: detalhesDemanda.enderecoExpedidor[0].latitudeCidade,
                  longitude:
                    detalhesDemanda.enderecoExpedidor[0].longitudeCidade,
                  address: capitalizar(
                    detalhesDemanda.enderecoExpedidor[0].cidade
                  ),
                }}
                endPosition={{
                  latitude: detalhesDemanda.enderecoRecebedor[0].latitudeCidade,
                  longitude:
                    detalhesDemanda.enderecoRecebedor[0].longitudeCidade,
                  address: capitalizar(
                    detalhesDemanda.enderecoRecebedor[0].cidade
                  ),
                }}
              />
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default DadosGerais;

const endereco = PropTypes.shape({
  bairro: PropTypes.string,
  cep: PropTypes.string,
  cidade: PropTypes.string,
  cnpj: PropTypes.string,
  complemento: PropTypes.string,
  endereco: PropTypes.string,
  estado: PropTypes.string,
  ibgeCidade: PropTypes.number,
  idCidade: PropTypes.number,
  idCliente: PropTypes.number,
  idClienteEndereco: PropTypes.number,
  idEstado: PropTypes.number,
  nomeCliente: PropTypes.string,
  numero: PropTypes.number,
  latitudeCidade: PropTypes.number,
  longitudeCidade: PropTypes.number,
});

const lotes = PropTypes.shape({
  volume: PropTypes.number,
  cadencia: PropTypes.number,
});

DadosGerais.propTypes = {
  detalhesDemanda: PropTypes.shape({
    enderecoDestino: PropTypes.arrayOf(endereco),
    enderecoExpedidor: PropTypes.arrayOf(endereco),
    enderecoOrigem: PropTypes.arrayOf(endereco),
    enderecoRecebedor: PropTypes.arrayOf(endereco),
    idClientePagador: PropTypes.number,
    cnpjClientePagador: PropTypes.string,
    razaoSocialClientePagador: PropTypes.string,
    idEspecie: PropTypes.number,
    idProduto: PropTypes.number,
    observacao: PropTypes.string,
    produtoNome: PropTypes.string,
    volumeTotal: PropTypes.number,
    cadenciaDiariaTotal: PropTypes.number,
    livreConcorrencia: PropTypes.bool,
    lotes: PropTypes.arrayOf(lotes),
    numPedidoCliente: PropTypes.string,
  }).isRequired,
};
